import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { OrganisationTypeEnum } from '../../../../enums/organisation-types';
import { JobScreenTaskDetails } from '../../../../interfaces/screen-specific/job-screen';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng';
import { BBWTMessageService, EventService, TaskService } from '../../../../services';
import {
  IRouteJobScreenTaskDetail,
  IRouteJobScreenTaskDetailTask,
} from '../../../../interfaces/screen-specific/job-screen/route-details/route-job-screen-task-detail';
import { RouteRecommendationService } from '../../../../services/route-recommendation.service';

@Component({
  selector: 'route-job-screen-tasks',
  templateUrl: './route-job-screen-tasks.component.html',
  styleUrls: ['./route-job-screen-tasks.component.scss'],
})
export class RouteJobScreenTasksComponent implements OnInit, OnDestroy, OnChanges {
  @Input() routeId: number;
  organisationTypeId: number = OrganisationTypeEnum.Supplier;

  tasks: IRouteJobScreenTaskDetailTask[] = [];
  routeRecommendation: IRouteJobScreenTaskDetail;

  taskDetails: JobScreenTaskDetails[];
  selectedTask: JobScreenTaskDetails;

  subscriptions: Subscription[] = [];

  public taskTypes: SelectItem[] = [];
  activeIndex: number = 0;
  selectedTaskId: number;

  constructor(
    private eventService: EventService,
    private taskService: TaskService,
    private routeRecommendationService: RouteRecommendationService,
    private messageService: BBWTMessageService,
  ) {}

  async ngOnInit() {
    void this.loadRoute();

    this.subscriptions.push(
      this.eventService.JobScreenEvent.subscribe((event: any) => {
        this.processEvents(event);
      }),
    );
  }

  private processEvents(event: any) {
    if (event.event == 'task-changed') {
      this.clickedTask(event.data.taskId, false);
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.routeId.currentValue) {
      void this.loadRoute();
    }
  }

  async loadRoute() {
    // Load job
    const routeDetails: IRouteJobScreenTaskDetail =
      await this.routeRecommendationService.getRouteJobScreenTaskDetails(this.routeId);

    this.routeRecommendation = routeDetails;
    this.tasks = routeDetails?.tasks || [];

    if (this.tasks.length === 0) {
      this.selectedTaskId = undefined;
      this.taskDetails = [];
      this.messageService.ShowError(
        'Failure',
        'Unable to load tasks for this route. Please refresh and try again.',
      );
      return;
    }

    this.selectedTaskId = this.tasks[0].id;

    const taskDetails = await this.taskService.getJobScreenTaskDetails(
      this.tasks.map((task) => task.id),
    );

    this.taskDetails = taskDetails;
    this.selectedTask = taskDetails.find((taskDetails) => taskDetails.id == this.selectedTaskId);
  }

  clickedTask(taskId: any, sendEvent: boolean = true) {
    this.selectedTaskId = taskId;
    this.selectedTask = this.taskDetails?.find((taskDetails) => taskDetails.id == taskId);

    if (sendEvent) {
      this.eventService.JobScreenEvent.emit({
        event: 'task-changed',
        data: { taskId: taskId, routeId: this.routeId },
        sender: 'clickedTask',
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x?.unsubscribe());
  }
}
